var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportCsvBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51833 0.468095L11.014 4.84059C11.3194 5.1269 11.3298 5.59942 11.0371 5.89809C10.8923 6.04008 10.6952 6.11994 10.4896 6.11994C10.284 6.11994 10.0869 6.04008 9.94209 5.89809L6.74195 2.80809V10.7806C6.74195 11.1948 6.39671 11.5306 5.97083 11.5306C5.54495 11.5306 5.19971 11.1948 5.19971 10.7806V2.80809L2.0227 5.89809C1.71675 6.15293 1.26069 6.13579 0.975858 5.85877C0.691031 5.58174 0.673415 5.13816 0.935423 4.84059L5.43105 0.468095C5.73181 0.177302 6.21756 0.177302 6.51833 0.468095Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11523 12.2806H9.82643C10.2523 12.2806 10.5975 12.6164 10.5975 13.0306C10.5975 13.4448 10.2523 13.7806 9.82643 13.7806H2.11523C1.68936 13.7806 1.34411 13.4448 1.34411 13.0306C1.34411 12.6164 1.68936 12.2806 2.11523 12.2806Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportCsvBlack);
export default __webpack_public_path__ + "static/media/exportCsvBlack.a83d8fff83b7a9fa1cb42ac51e14998e.svg";
export { ForwardRef as ReactComponent };